export default __webpack_public_path__ + "static/media/velugapudi-shankar.818e8f10.png";